<template>
  <TheFooter>
    <div>
      <!--footer-->
      <a href="https://ux.app">v{{ getVersion }}</a>
      <span class="ml-1"
        >&copy; {{ new Date().getFullYear() }} ux.app - support portal</span
      >
    </div>
    <div class="ml-auto">
      <!-- <a
        class="btn btn-sm btn-outline-warning mr-2"
        href="https://UxAppSupport.statuspage.io/"
        target="_blank"
      >
        <i class="fa fa-info mr-2" />
        <span>Status</span>
      </a>
      <a
        class="btn btn-sm btn-outline-info mr-2"
        href="/help/index.html"
        target="_blank"
      >
        <i class="fa fa-life-ring mr-2" />
        <span>Documentation</span>
      </a> -->

      <!-- <span class="mr-1">Powered by</span>
      <a href="https://commissions.io">commissions.io</a> -->
    </div>
  </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue';
import { mapGetters } from 'vuex';
export default {
  name: 'DefaultFooter',
  computed: {
    ...mapGetters(['getVersion'])
  },
  components: {
    TheFooter
  }
};
</script>
